export default __webpack_public_path__ + "static/media/truck.8d6f33de.png";